import React from 'react';
import Link from 'next/link';

export default function LandingFooter() {
  return (
    <footer className="bg-foreground text-white">
      <div className="max-w-screen-xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-10 mb-12">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <span className="font-extrabold text-xl text-white">OFY</span>
            </div>
            <p className="text-sm text-white/60 leading-relaxed mb-5">
              Hyperlocal offers connecting local businesses with nearby customers. Discover, save, support local.
            </p>
          </div>

          <div>
            <p className="text-sm font-semibold text-white mb-4">For Customers</p>
            <ul className="flex flex-col gap-2.5">
              {['Discover Offers', 'Browse Categories', 'Sign Up Free', 'How It Works']?.map((item) => (
                <li key={`footer-customer-${item}`}>
                  <Link href="/customer-home-discover" className="text-sm text-white/60 hover:text-white transition-colors">
                    {item}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <p className="text-sm font-semibold text-white mb-4">For Businesses</p>
            <ul className="flex flex-col gap-2.5">
              {['List Your Business', 'Create Offers', 'Business Dashboard']?.map((item) => (
                <li key={`footer-biz-${item}`}>
                  <Link href="/business-sign-up-login" className="text-sm text-white/60 hover:text-white transition-colors">
                    {item}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <p className="text-sm font-semibold text-white mb-4">Company</p>
            <ul className="flex flex-col gap-2.5">
              {['About OFY', 'Blog', 'Careers', 'Privacy Policy', 'Terms of Service']?.map((item) => (
                <li key={`footer-company-${item}`}>
                  <Link href="/" className="text-sm text-white/60 hover:text-white transition-colors">
                    {item}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-sm text-white/40">© 2026 OFY. All rights reserved.</p>
          <div className="flex items-center gap-4">
            <Link href="/" className="text-sm text-white/40 hover:text-white transition-colors">Privacy</Link>
            <Link href="/" className="text-sm text-white/40 hover:text-white transition-colors">Terms</Link>
            <Link href="/" className="text-sm text-white/40 hover:text-white transition-colors">Support</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}